const BOOK_SESSION_LINK = "https://scheduler.zoom.us/nicholas-castle-rta0y9/your-calm-but-capable-book-session";

export default function BookThankYouPage() {
  return (
    <main className="public-home book-thank-you-page">
      <header className="public-header">
        <a className="public-brand" href="/" aria-label="Calm But Capable home">
          <img src="/logo-white.png" alt="" className="public-logo" />
          <span>Calm But Capable</span>
        </a>
      </header>
      <section className="book-thank-you-card">
        <p className="public-kicker">Order received</p>
        <h1>Thank you for beginning with us.</h1>
        <p>
          Your payment has been received. We will email you when your book has
          been dispatched, together with information about the free workshop
          and your included personal Book Session.
        </p>
        <div className="book-thank-you-booking">
          <h2>Choose a time for your included session</h2>
          <p>
            Book your personal 30-minute Zoom session now while taking this next
            step is fresh in your mind. Choose a suitable date and add it to your
            calendar so it is not forgotten.
          </p>
          <a className="book-button" href={BOOK_SESSION_LINK}>Book My Included Session</a>
        </div>
        <p className="book-thank-you-help">
          If you have any questions, email <a href="mailto:hello@calmbutcapable.com">hello@calmbutcapable.com</a>.
        </p>
        <a className="book-secondary-link" href="/sanctuary">Explore The Sanctuary</a>
      </section>
    </main>
  );
}
